const errorCodes = {
  BAD_REQUEST_ERROR: "BAD_REQUEST_ERROR",
};

export default errorCodes;
